/* eslint-disable react/jsx-key */
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Row, Col, Card, Pagination, Avatar, Modal, Button, Alert, Divider } from 'antd';
import moment from 'moment';
import Image from '../../Images/health1.png';
import Click from '../../Images/click.png';
import './style.css';
import { FolderOpenOutlined } from '@ant-design/icons';
import { selectClickedHealthRecordId, selectHealthRecords, selectHealthRecordsPage, selectLoading } from './Selectors';
import { clickedHealthRecordIdRequest, healthRecordImageRequest, healthRecordRequest } from './Actions';
import { useNavigate } from 'react-router-dom';
import CustomSpin from '../CommonSpin';
import { BodyTextGrey, ButtonText, ModalHeading, ModalTittle, TittleHeader } from '../CommonText';

import english from '../../Translations/English.json';
import hindi from '../../Translations/Hindi.json';
import malayalam from '../../Translations/Malayalam.json';

const HealthRecord = () => {
    const [currentPage, setCurrentPage] = useState(1);
    const [visible, setVisible] = useState(false);

    const langid = localStorage.getItem('INTL') ? (localStorage.getItem('INTL')) : 'en';
    const langdata = langid && langid == 'en' ? english : langid == 'ma' ? malayalam : langid == 'hin' ? hindi : english;


    const dispatch = useDispatch();
    const navigate = useNavigate();
    
    const healthRecords = useSelector(selectHealthRecords);
    const requesting = useSelector(selectLoading);
    const clickedHeal = useSelector(selectClickedHealthRecordId);
    const count = useSelector(selectHealthRecordsPage);

    const totalPage = Math.ceil(count / 12) * 10;
    
    const patientId = sessionStorage.getItem('PATIENT_ID');    
    
    useEffect(() => {
        if (!patientId) {
            Modal.warning({
                title: 'Complete your profile',
                content: 'Please complete your profile details here...',
            });
            navigate('/addprofile');
        }
    },[]);
        
    useEffect(() => {
        dispatch(healthRecordRequest(1));
    }, []);


    const handlePage = (page) => {
        setCurrentPage(page);
        dispatch(healthRecordRequest(page));
    };

    const handleCard = () => {
        setVisible(true);
    };

    const handleOk = () => {
        setVisible(false);
    };

    const handleCancel = () => {
        setVisible(false);
    };

    // const count = localStorage.getItem('QUIKDRTOTALHEALTH');
    // const totalPage = Math.ceil(count / 8) * 10;    

    const modal = healthRecords && healthRecords.map((item) => {
        if (item.id === clickedHeal) {
            const healthData = item.healthRecord;
            const body = Object.keys(healthData).map((key) => (
                <div className="list-group-item" key={key} style={{ paddingTop: '10px' }}>
                    <b>{key}</b> <Divider type="vertical" />
                    <a className="pull-right">{healthData[key]}</a>
                    <Divider style={{ marginTop: '5px', marginBottom: '-3px' }} />
                </div>
            ));

            return (
                <Modal
                    open={visible}
                    onOk={handleOk}
                    onCancel={handleCancel}
                    width={683}
                    footer={false}
                    style={{ marginTop: '10px' }}
                    className="bg-bgwhite"
                >
                    {/* <Row> */}
                    <Row
                        style={{
                            background: '#1164A6',
                            height: '100px',
                            // width: '683px',
                            marginTop: '-20px',
                            marginRight: '-24px',
                            marginLeft: '-24px',
                            borderRadius: '8px 8px 0px 0px',
                            display : 'flex'
                        }}
                    >
                        <Col span={17} style={{ marginTop: '32px', marginLeft: '20px' }}>
                            <div style={{ color: '#FFFFFF', fontSize: '25px' }}>
                                <ModalTittle text = {item.organisationName} color = '#ffffff' />
                            </div>
                        </Col>
                        <Col
                            span={6}
                            style={{ marginTop: '42px', color: '#FFFFFF', fontSize: '15px' }}
                        >
                            <div>
                                    On: {moment(item.createdAt).format('DD')} - {moment(item.createdAt).format('MMM')} -{' '}
                                {moment(item.createdAt).format('YYYY')}
                            </div>
                        </Col>                        
                    </Row>
                    {/* </Row> */}
                    <Row>
                        <Col span={24}>
                            <Row>
                                <Col xs={{ span: 24 }} lg={{ span: 16 }} style={{ marginTop: '2%', marginBottom: '10%' }}>
                                    <div style={{ color: '#4F4F4F', fontFamily: 'Roboto', fontSize: '21px' }}>
                                        <ModalHeading text = {`${langdata.RecordType ? langdata.RecordType : 'Record Type' }`} />
                                    </div>
                                    <div>{item.healthRecType}</div>
                                </Col>
                                <Col
                                    xs={{ offset: 1, span: 24 }}
                                    lg={{ span: 8, offset: 15 }}
                                    style={{ marginTop: '-12%', textAlign: 'right' }}
                                >
                                    {item.fileurl !== null ? (
                                        <Card
                                            style={{ paddingLeft: '10%', cursor: 'pointer' }}
                                            bordered={false}
                                            onClick={() => {
                                                // dispatch({ type: RECORD_IMAGE_OPEN, payload: item.fileurl });
                                                dispatch(healthRecordImageRequest(item.fileurl));
                                            }}
                                        >
                                            <Avatar style={{ cursor: 'pointer' }} shape="square" size={87} icon="user" src={Click} />
                                        </Card>
                                    ) : (
                                        <div>{body}</div>
                                    )}
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                    {/* <Row>
                        <Col xs={{ span: 0 }} lg={{ span: 0 }}>
                            <Button className="ant_btt" style={{ float: 'right', marginTop: '25px', marginRight: '10px' }}>
                                Send Email
                            </Button>
                        </Col>
                    </Row> */}
                </Modal>
            );
        }
        return null;
    });

    const healthRecordsBody = healthRecords && healthRecords.map((item) => (
        <div key={item.id} style={{ float: 'left', paddingLeft: '35px' }}>
            <Card
                className="cardH"
                style={{ height: '340px' }}
                onClickCapture={handleCard}
                onClick={() => {
                    dispatch(clickedHealthRecordIdRequest(item.id));
                }}
            >
                <Row>
                    <Col span={24}>
                        <div style={{ paddingBottom: '12px', justifyContent:'center', display:'flex' }}>
                            <Avatar src={Image} size={40} />
                        </div>
                        <div
                            style={{
                                marginLeft: '20px',
                                textAlign: 'left',
                                // fontFamily: 'Roboto',
                                color: '#828282',
                                fontSize: '14px',
                            }}
                        >
                            <BodyTextGrey text = {`${langdata.ReportType ? langdata.ReportType : 'Report Type' }`} />
                        </div>
                        <div
                            style={{
                                marginLeft: '20px',
                                // paddingTop: '2px',
                                textAlign: 'left',
                                // fontFamily: 'Roboto',
                                color: '#1164A6',
                                fontSize: '14px',
                            }}
                        >
                            {item.healthRecType}
                        </div>
                        <div
                            style={{
                                marginLeft: '20px',
                                marginTop: '10px',
                                textAlign: 'left',
                                // fontFamily: 'Roboto',
                                color: '#828282',
                                fontSize: '14px',
                            }}
                        >
                            <BodyTextGrey text = {`${langdata.PatientName ? langdata.PatientName : 'Patient Name' }`} />
                        </div>
                        <div
                            style={{
                                marginLeft: '20px',
                                // paddingTop: '2px',
                                textAlign: 'left',
                                // fontFamily: 'Roboto',
                                color: '#000000',
                                fontSize: '14px',
                            }}
                        >
                            {`${item.firstName} ${item.lastName}`}
                        </div>
                        <div
                            style={{
                                marginLeft: '20px',
                                marginTop: '10px',
                                textAlign: 'left',
                                // fontFamily: 'Roboto',
                                color: '#828282',
                                fontSize: '14px',
                            }}
                        >
                            <BodyTextGrey text = {`${langdata.CreatedBy ? langdata.CreatedBy : 'Created By' }`} />
                        </div>
                        <div
                            style={{
                                marginLeft: '20px',
                                // paddingTop: '2px',
                                textAlign: 'left',
                                // fontFamily: 'Roboto',
                                color: '#000000',
                                fontSize: '14px',
                            }}
                        >
                            {item.organisationName}
                        </div>
                        <div
                            style={{
                                marginLeft: '20px',
                                marginTop: '10px',
                                textAlign: 'left',
                                // fontFamily: 'Roboto',
                                color: '#828282',
                                fontSize: '14px',
                            }}
                        >
                            <BodyTextGrey text = {`${langdata.CreatedOn ? langdata.CreatedOn : 'Created On' }`} />
                        </div>
                        <div
                            style={{
                                marginLeft: '20px',
                                // paddingTop: '2px',
                                textAlign: 'left',
                                // fontFamily: 'Roboto',
                                color: '#000000',
                                fontSize: '14px',
                            }}
                        >
                            {moment(item.createdAt).format('DD')} - {moment(item.createdAt).format('MMM')} -{' '}
                            {moment(item.createdAt).format('YYYY')}
                        </div>
                        <div
                            style={{
                                marginLeft: '20px',
                                marginTop: '10px',
                                textAlign: 'left',
                                // fontFamily: 'Roboto',
                                color: '#828282',
                                fontSize: '14px',
                            }}
                        >
                            <BodyTextGrey text = {`${langdata.HealthRecordID ? langdata.HealthRecordID : 'Health Record ID' }`} /> : {item.id}
                        </div>
                    </Col>
                </Row>
            </Card>
        </div>
    ));

    return (
        <div>
            <Row type="flex" justify="center">
                <Col xs={{ span: 24 }} md={{ span: 24 }}>
                    <Col
                        xs={{ span: 24 }}
                        md={{ span: 24 }}
                        style={{
                            marginTop: '5px',
                            marginBottom: '15px',
                        }}
                    >
                        <Col
                            xs={{ span: 23 }}
                            md={{ span: 23 }}
                            lg={{ span: 23 }}
                            xl={{ span: 23 }}
                            xxl={{ span: 23 }}
                            style={{
                                marginLeft: '2%',
                                background: '#fff',
                                boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.04)',
                                borderRadius: '4px',
                            }}
                        >
                            <Row>
                                <Col xs={{ span: 24 }} md={{ span: 16 }} lg={{ span: 10 }} xl={{ span: 10 }} xxl={{ span: 10 }} style={{ textAlign: 'right' }}>
                                    <div
                                        style={{
                                            marginLeft: '1%',
                                            textAlign: 'left',
                                            fontFamily: 'Roboto',
                                            fontSize: '27px',
                                            color: '#1164A6',
                                            padding: '8px',
                                            display: 'flex'
                                        }}
                                    >
                                        <FolderOpenOutlined style={{ fontSize: '30px' }} /> <TittleHeader text = {`${langdata.MyHealthRecord ? langdata.MyHealthRecord : 'My Health Record' }`} color='#1164A6'/>
                                    </div>
                                </Col>
                                <Col xs={{ span: 24 }} md={{ span: 8 }} lg={{ span: 14 }} xl={{ span: 14 }} xxl={{ span: 14 }} style={{ textAlign: 'right', paddingTop: '12px', paddingBottom: '10px' }}>
                                    <span >
                                        <Button
                                            style={{ margin : '10px'}}
                                            type="primary"
                                            onClick={() => {
                                                navigate('/healthrecupload');                                                
                                            }}
                                        >
                                            <ButtonText text = {`${langdata.UploadHealthRecord ? langdata.UploadHealthRecord : 'Upload Health Record' }`} />
                                        </Button>
                                    </span>
                                </Col>
                            </Row>
                        </Col>
                    </Col>
                </Col>
            </Row>

            <Row>
                <Col xs={{ span: 22, offset: 2 }} lg={{ span: 24, offset: 0 }} style={{ marginTop: '8px', minHeight: '400px' }}>
                    <div style={{ marginTop: '20px', marginLeft: '2%' }}>
                        {healthRecordsBody && healthRecordsBody.length > 0 ? (
                            <div>
                                {healthRecordsBody}
                                <Col xs={{ span: 12 }}>{modal}</Col>
                            </div>
                        ) : (
                            <Col xs={{ span: 22 }} lg={{ span: 23 }}>
                                <div style={{ textAlign: 'center' }}>
                                    {/* <h1> */}
                                    <Alert message={`${langdata.NoHealthrecord ? langdata.NoHealthrecord : 'No Health record!' }`} description={`${langdata.SorryNoHealthRecordavailable ? langdata.SorryNoHealthRecordavailable : 'Sorry No Health Record available'}`} type="info" />
                                    {/* </h1> */}
                                </div>
                            </Col>
                        )}
                    </div>
                    {/* <Row>
                        <Col xs={{ span: 24, offset: 0 }} md={{ offset: 10 }} lg={{ span: 24, offset: 0 }} style={{ marginTop: '15px', textAlign: 'center' }}>
                            {totalPage > 10 && (
                                <Pagination defaultCurrent={1} onChange={handlePage} total={totalPage} />
                            )}
                        </Col>
                    </Row> */}
                </Col>
                <Col
                    xs={{ span: 24 }}
                    style={{ textAlign: 'center', marginTop: '20px', marginBottom: '10px', display: 'flex', justifyContent: 'center' }}
                >
                    <Pagination
                        xs={{ span: 24 }}
                        lg={{ span: 24 }}
                        defaultCurrent={1}
                        hideOnSinglePage
                        current={currentPage}
                        onChange={handlePage}
                        total={parseInt(totalPage)}
                        showSizeChanger={false}
                    />
                </Col>
            </Row>
            <CustomSpin spinning={requesting} />
        </div>
    );
};

export default HealthRecord;
